import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Thankyou from '@/views/Thankyou'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/thankyou',
    name: 'Thank you',
    component: Thankyou
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
